import * as fromInvoice from '../actions/invoice.action';
import {Invoice} from '../../invoice';


export interface InvoiceState {
  entities: Invoice[];
  entity?: Invoice;
  loading: boolean;
  loaded: boolean;
  error: string;
  isUpdated: boolean;
}

export const initialState = {
  entities: null,
  loading: false,
  loaded: true,
  error: null,
  entity: null,
  isUpdated: false,
};

export function reducer(state = initialState, action: fromInvoice.InvoiceAction): InvoiceState {
  switch (action.type) {
    case fromInvoice.GET_ALL_INVOICES: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromInvoice.GET_ALL_INVOICES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: action.payload,
        error: null
      };
    }
    case fromInvoice.GET_ALL_INVOICES_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: null,
        entity: null,
        error: action.payload
      };
    }
    case fromInvoice.UPDATE_INVOICE_SUCCESS: {
      if (state.entities) {
        state.entities.filter((invoice, index) => {
          if (invoice.id === action.payload.id) {
            state.entities[index] = action.payload;
          }
        });
      }
      return {
        ...state,
        entity: action.payload,
        error: null,
        isUpdated: true,
      };
    }
    case fromInvoice.UPDATE_INVOICE: {
      return {
        ...state,
        entity: action.payload,
        error: null,
        isUpdated: false,
      };
    }
    case fromInvoice.UPDATE_INVOICE_ERROR: {
      return {
        ...state,
        error: action.payload,
        isUpdated: true,
      };
    }
    case fromInvoice.APPROVE_INVOICE_PAYMENT: {
      return {
        ...state,
        error: null
      };
    }
    case fromInvoice.APPROVE_INVOICE_PAYMENT_SUCCESS: {
      return {
        ...state,
        entity: action.payload,
        error: null
      };
    }
    case fromInvoice.APPROVE_INVOICE_PAYMENT_ERROR: {
      return {
        ...state,
        error: action.payload,
      };
    }
  }

  return state;
}




// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/invoices/store/reducers/invoice.reducer.ts